import { type ApolloError } from "@apollo/client";
import { type ReactNode } from "react";

export function isAuthWallError(error: ApolloError | undefined): boolean {
  if (!error) return false;
  return error.graphQLErrors.some((e) => {
    // connect-gql's formatError flattens auth errors to TOP-LEVEL code/name
    // (extensions field absent), but check both for defense-in-depth.
    const code = (e as { code?: string }).code ?? e.extensions?.code;
    const name = (e as { name?: string }).name ?? e.extensions?.name;

    return (
      code === "UNAUTHENTICATED" ||
      code === "FORBIDDEN" ||
      code === "401" ||
      code === "403" ||
      name === "AuthenticationError" ||
      name === "JWTError" ||
      e.message?.includes("401") ||
      e.message?.includes("403")
    );
  });
}

interface AdminWallProps {
  error: ApolloError | undefined;
  screenLabel: string;
  children: ReactNode;
}

export function AdminWall({ error, screenLabel, children }: AdminWallProps) {
  if (isAuthWallError(error)) {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
        <div className="text-4xl mb-4" aria-hidden="true">🔒</div>
        <h2 className="text-lg font-bold mb-2">Entra ADMIN access required</h2>
        <p className="text-sm text-muted-foreground max-w-md mb-4">
          <strong>{screenLabel}</strong> management requires an Entra ADMIN identity.
          Sign in with an Entra account that has the admin role to manage users, personas, and feature flags.
        </p>
      </div>
    );
  }
  return <>{children}</>;
}
